import zh from "./zh";
import en from "./en";
import config from "../config/config";
import { isEmpty, is3DView } from "../util/util";

const i18nMap = {
    zh,
    en
}

/**
 * 判断是否是国际化字符串，默认判断 $ 开头，此逻辑可根据项目情况变更
 * @param key 
 * @returns 
 */
export const isI18nString = function (key) {
    return key.startsWith('$');
}

/**
 * 获取国际化字符串
 * @param key 键名
 * @param params 参数列表，如 [ 'name', 'age' ] 将对应替换原始串中的 {0} {1}
 */
export const getI18n = function (key, ...params) {
    const map = i18nMap[config.locale];
    if (!map) {
        console.warn(`i18n local missing: [${config.locale}]`)
        return key;
    }
    let str = map[key];
    if (isEmpty(str)) {
        console.log(`i18n key missing: [${key}]`);
        return key;
    }
    if (params && params.length) {
        params.forEach((p, i) => {
            str = str.replace(new RegExp(`\\{${i}\\}`, 'g'), p);
        });
    }
    return str;

}

/**
 * 更新 DataModel 中所有国际化更新
 * @param dm 
 */
export const updateDMI18n = function (dm) {
    dm.each((data) => {
        var dataBindings = data.getDataBindings();
        if (dataBindings) {
            let handle = false;
            // update attrs
            for (var name in dataBindings.a) {
                var db = dataBindings.a[name];
                if (isI18nString(db.id)) {
                    var value = getI18n(db.id);
                    if (db.func) {
                        value = db.func(value);
                    }
                    data.a(name, value);
                }
            }
            // update styles
            for (var name in dataBindings.s) {
                var db = dataBindings.s[name];
                if (isI18nString(db.id)) {
                    var value = getI18n(db.id);
                    if (db.func) {
                        value = db.func(value);
                    }
                    data.s(name, value);
                }
            }
            // update properties
            for (var name in dataBindings.p) {
                var db = dataBindings.p[name];
                if (isI18nString(db.id)) {
                    var value = getI18n(db.id);
                    if (db.func) {
                        value = db.func(value);
                    }
                    (data)[ht.Default.setter(name)](value);
                }
            }
        }
    });
}

/**
 * 更新视图 中的DataModel 中所有国际化更新，如果是 3D 会更新矢量贴图缓存
 * @param  view
 */
export const updateViewI18n = function (view) {
    view.dm().each((data) => {
        var dataBindings = data.getDataBindings();
        if (dataBindings) {
            let handle = false;
            // update attrs
            for (var name in dataBindings.a) {
                var db = dataBindings.a[name];
                if (isI18nString(db.id)) {
                    var value = getI18n(db.id);
                    if (db.func) {
                        value = db.func(value);
                    }
                    data.a(name, value);
                    handle = true;
                }
            }
            // update styles
            for (var name in dataBindings.s) {
                var db = dataBindings.s[name];
                if (isI18nString(db.id)) {
                    var value = getI18n(db.id);
                    if (db.func) {
                        value = db.func(value);
                    }
                    data.s(name, value);
                    handle = true;
                }
            }
            // update properties
            for (var name in dataBindings.p) {
                var db = dataBindings.p[name];
                if (isI18nString(db.id)) {
                    var value = getI18n(db.id);
                    if (db.func) {
                        value = db.func(value);
                    }
                    (data)[ht.Default.setter(name)](value);
                    handle = true;
                }
            }

            if (handle && is3DView(view)) {
                view.invalidateCachedTexture(data);
            }
        }
    });
}